export const SITE = {
  name: "TOP WASH",
  url: process.env.REACT_APP_SITE_URL || "https://top-wash.rs",
  email: "info@top-wash.rs",
  phone: "061 140 9075",
  phoneHref: "tel:+381611409075",
  address: {
    street: "Snežane Hrepevnik 55",
    city: "Beograd (Rakovica)",
    postalCode: "11090",
    country: "Srbija",
  },
  pib: "115701487",
  mb: "22195093",
  hours: "Pon — Pet 08:00 — 20:00 · Sub 09:00 — 15:00",
  logo: "https://customer-assets.emergentagent.com/job_fur-clean-visual/artifacts/dacmtrqz_top-wash.png",
  tagline: "Profesionalna B2B perionica za restorane, hotele i spa centre u Beogradu",
};

export const DEFAULT_SEO = {
  title: "TOP WASH DOO — Profesionalno pranje veša i tekstila za ugostiteljstvo | Beograd",
  description:
    "TOP WASH DOO — vodeća B2B perionica u Beogradu za restorane, hotele, kafiće i spa centre. Profesionalno pranje posteljine, stolnjaka, peškira i uniformi. Industrijska hemija, omekšivači premium klase, besplatna procena, fiksni raspored dostave.",
  keywords:
    "profesionalno pranje veša Beograd, perionica za hotele Beograd, pranje posteljine hotel, pranje stolnjaka restoran, B2B perionica ugostiteljstvo, TOP WASH DOO, pranje uniformi restoran, pranje peškira spa, industrijsko pranje tekstila, servis pranja veša za biznis, pranje jorgana hotel, rotacija posteljine Beograd, perionica Rakovica, profesionalni omekšivač za veš",
};
